var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgNotifications = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 13,
  height: 16,
  viewBox: "0 0 13 16",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M9.174 13a3 3 0 0 1-6 0zm1-8q0 .18-.016.357c.142 2.847 1.907 4.976 1.907 4.976.596.938.21 1.667-.897 1.667H1.18c-1.11 0-1.506-.736-.89-1.645 0 0 1.68-2 1.943-4.668a4.002 4.002 0 0 1 2.949-4.563 1 1 0 1 1 1.985 0A4 4 0 0 1 10.173 5"
})));
export default SvgNotifications;